import { TextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from '#src/pages/manage/security-breach/SecurityBreach.tsx';

import { nonEmptyString } from '../validation.ts';

export const DataType = () => {
  const { setValue } = useFormContext<FormValues>();
  return (
    <Controller
      name="dataType"
      rules={{
        validate: nonEmptyString(
          'Enter the type of data that has been exposed',
        ),
      }}
      render={({ field, fieldState }) => (
        <TextField
          required
          characterLimit={255}
          id="security-breach-data-type"
          onChange={field.onChange}
          label="What type of data has been exposed?"
          secondaryLabel="e.g. hirer contact details, job applications, job ad details, SEEK API credentials"
          value={field.value}
          onClear={() => setValue('dataType', '')}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
        />
      )}
    />
  );
};
